import { listOptions } from '@/api/business/trailerTransportOrder'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(listOptions)
